export const HERO_IMG = "/images/hero-vials.png";
export const LAB_IMG = "https://images.unsplash.com/photo-1724860755552-55f1c46f763d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxzY2llbmNlJTIwbGFib3JhdG9yeSUyMHZpYWxzfGVufDB8fHx8MTc4NjI5MjMwN3ww&ixlib=rb-4.1.0&q=85";
export const VIAL_GROUP_IMG = "https://images.unsplash.com/photo-1576671081837-49000212a370?q=85&w=1600&auto=format&fit=crop";
export const VIAL_PIPETTE_IMG = "https://images.unsplash.com/photo-1579165466741-7f35e4755660?q=85&w=1600&auto=format&fit=crop";
export const VIAL_TUBES_IMG = "https://images.unsplash.com/photo-1631556763178-b96af5e9993e?q=85&w=1600&auto=format&fit=crop";
export const VIAL_LINED_IMG = "https://images.unsplash.com/photo-1715442354511-d98c5a3a7fe8?q=85&w=1600&auto=format&fit=crop";
export const VIAL_GRAYSCALE_IMG = "https://images.unsplash.com/photo-1576671081803-5dcb9836dc61?q=85&w=1600&auto=format&fit=crop";

// Static enrichment data (purity, CAS, storage, imagery) for known catalog items.
// The live catalog always comes from the API — this is display metadata only.
export const PRODUCTS = [
  {
    id: "tirzepatide",
    name: "Tirzepatide",
    category: "Peptide",
    size: "10 mg",
    price: 85,
    stock: 14,
    purity: "≥ 99.3% (HPLC)",
    cas: "2023788-19-2",
    form: "Lyophilized powder",
    storage: "−20°C, desiccated",
    batch: "VF-2608-TRZ",
    image: "/images/tirzepatide.png",
    description: "Dual GIP/GLP-1 receptor agonist research compound. Every lot verified by third-party HPLC and mass spectrometry with batch-specific COA.",
  },
  {
    id: "ghk-cu",
    name: "GHK-Cu",
    category: "Peptide",
    size: "50 mg",
    price: 55,
    stock: 40,
    purity: "≥ 99.0% (HPLC)",
    cas: "49557-75-7",
    form: "Lyophilized powder",
    storage: "−20°C, desiccated",
    batch: "VF-2608-GHK",
    image: "/images/ghk-cu.png",
    description: "Copper tripeptide complex for in-vitro research, supplied as a characteristic blue lyophilized powder. Purity and copper content verified per batch.",
  },
  {
    id: "semax",
    name: "Semax",
    category: "Peptide",
    size: "10 mg",
    price: 48,
    stock: 22,
    purity: "≥ 99.1% (HPLC)",
    cas: "80714-61-0",
    form: "Lyophilized powder",
    storage: "−20°C, desiccated",
    batch: "VF-2608-SMX",
    image: "/images/semax.png",
    description: "Heptapeptide research analog supplied lyophilized under nitrogen. Released only against independent HPLC and MS confirmation.",
  },
  {
    id: "bac-water",
    name: "Hospira Bacteriostatic Water",
    category: "Diluent",
    size: "30 mL",
    price: 12,
    stock: 60,
    purity: "USP grade · 0.9% benzyl alcohol",
    cas: "7732-18-5",
    form: "Sterile solution, multi-dose vial",
    storage: "20–25°C, protect from light",
    batch: "VF-2607-HBW",
    image: "/images/bac-water.png",
    description: "Genuine Hospira bacteriostatic water for injection, USP, preserved with 0.9% benzyl alcohol. Sourced through licensed pharmaceutical distribution channels.",
  },
];

export const COA_ROWS = [
  { batch: "VF-2607-HBW", pid: "bac-water", product: "Bacteriostatic Water 30 mL", purity: "USP conform", method: "USP monograph", endotoxin: "< 0.25 EU/mL", date: "2026-05-30", status: "Released" },
  { batch: "VF-2608-TRZ", pid: "tirzepatide", product: "Tirzepatide 10 mg", purity: "99.3%", method: "HPLC / MS", endotoxin: "< 0.05 EU/mg", date: "2026-07-10", status: "Released" },
  { batch: "VF-2608-GHK", pid: "ghk-cu", product: "GHK-Cu 50 mg", purity: "99.0%", method: "HPLC / MS", endotoxin: "< 0.10 EU/mg", date: "2026-07-08", status: "Released" },
  { batch: "VF-2608-SMX", pid: "semax", product: "Semax 10 mg", purity: "99.1%", method: "HPLC / MS", endotoxin: "< 0.05 EU/mg", date: "2026-07-05", status: "Released" },
];

export const FAQ_ITEMS = [
  {
    q: "Is there a payment processing fee?",
    a: "A 3.75% processing fee applies to PayPal and all card payments — it is shown as its own line at checkout before you submit, so there are no surprises. Venmo, CashApp, and Zelle payments carry no fee.",
  },
  {
    q: "What is your return or refund policy?",
    a: "All sales are final. It is the goal of VetForge Health and Wellness to provide a world class experience — if we do not meet those expectations with an order issue, please allow us the opportunity to reconcile the situation. Contact us and we will make it right.",
  },
  {
    q: "Who can order from VetForge?",
    a: "We supply verified researchers, laboratories, and institutions. Every visitor must confirm they are 21 or older and accept our research-use-only terms before browsing. Orders may be subject to additional verification.",
  },
  {
    q: "Are your products for human consumption?",
    a: "No. All products are sold strictly for laboratory research purposes only. They are not for human or veterinary consumption, not dietary supplements, and not intended to diagnose, treat, cure, or prevent any disease.",
  },
  {
    q: "Do you provide Certificates of Analysis?",
    a: "Yes. Every batch is independently tested by HPLC and mass spectrometry, and a batch-specific COA is available on request with every order. Summaries are published on our Quality page.",
  },
  {
    q: "How should products be stored?",
    a: "Lyophilized peptides should be stored at −20°C, desiccated and protected from light. Hospira bacteriostatic water should be kept at 20–25°C. Full storage guidance ships with every order.",
  },
  {
    q: "How do I place an order?",
    a: "Add products to your cart and submit the checkout form with your contact and shipping details. VetForge confirms your order and stock availability before any payment is requested, then contacts you with confirmation and payment instructions.",
  },
  {
    q: "How are orders shipped?",
    a: "Peptides ship cold-chain in insulated packaging with temperature monitoring. Diluents ship at ambient temperature. Tracking is provided on dispatch.",
  },
];
